// src/components/globales/ProtectedLayout.jsx

import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { GiHamburgerMenu } from 'react-icons/gi';
import { useAuth } from '../../auth/context/AuthContext';
import NavBar from './NavBar';
import Footer from './Footer';

const ProtectedLayout = () => {
    const { isLoggedIn } = useAuth();
    const [showNav, setShowNav] = useState(true);

    // Si no está logueado, redirige a /login
    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    return (
        <>
            {/* ================= HEADER ================= */}
            <header className="pl-header">
                <GiHamburgerMenu
                    className="hamburger-icon"
                    size={30}
                    onClick={() => setShowNav(!showNav)}
                />
            </header>

            {/* ================ CONTENEDOR PRINCIPAL: Flex ================ */}
            <div className="pl-container">
                {/* Sidebar/​NavBar */}
                <NavBar showNav={showNav} />

                {/* Zona de contenido (Outlet) */}
                <div className={showNav ? 'main' : 'main full-width'}>
                    <Outlet />
                    <Footer showNav={showNav} />
                </div>
            </div>
        </>
    );
};

export default ProtectedLayout;
